import { tracking } from '@bark/bark-core';
import ReviewStars from '../../helpers/review-stars';

export const isRequestQuoteUpsellActive = (projectHash) => {
	return !hasbeenDisplayed(projectHash) && requestQuoteFromAllIsActive();
};

export const canSetUpRequestQuoteUpsell = (projectHash) => {
	return !hasbeenDisplayed(projectHash);
};

export const setUpRequestQuoteUpsell = (sellerList) => {
	const sellers = getSellerDataRows(sellerList, 'project_sellers');
	const template = Handlebars.compile(
		document.getElementById('request-quote-upsell-sellers').innerHTML,
	);
	$('#buyer-quote-upsell-modal-sellers').html(template({ sellers: sellers }));
};

export const displayRequestQuoteUpsell = async (projectHash) => {
	await new Promise((r) => setTimeout(() => r(true), 600)); // wait for previous modal to close
	if (
		isRequestQuoteUpsellActive(projectHash) &&
		$('.buyer-quote-upsell-seller').length > 0
	) {
		$('#buyer-quote-upsell-modal').modal('show');
		bindListeners();
		tracking('Feature', 'request_quote_upsell - view', {
			projectId: getProjectHash(),
		});
	}

	window.Bark.set_cookie('rq_upsell_' + getProjectHash(), 1, 30, '/');
};

export const removeRequestedSeller = (sellerProfileId) => {
	$(`#request_quote_upsell_${sellerProfileId}`).remove();
};

const hasbeenDisplayed = (projectHash) => {
	return window.Bark.get_cookie(`rq_upsell_${projectHash}`) == 1;
};

const requestQuoteFromAllIsActive = () => {
	return $('.rqfa-container').length > 0;
};

const getProjectHash = () => {
	return $('#project-id').val();
};

const getSellerDataRows = (sellers, listType = 'project_sellers') => {
	return sellers
		.reduce((filtered, item) => {
			if (
				item.type === listType &&
				item.attributes.quote_status === null
			) {
				filtered.push({
					sellerIdHash: item.id,
					companyName: item.attributes.company_name,
					starsHtml: ReviewStars().generateStars(item.attributes.reviews_score),
					reviewsCount: item.attributes.reviews_count,
				});
			}
			return filtered;
		}, [])
		.slice(0, 5);
};

const bindListeners = () => {
	const checkboxes = $('input[type=checkbox][name=request-quote-upsell-sellers]');
	let enabledSellers = [];
	checkboxes.change(function () {
		enabledSellers = checkboxes
			.filter(':checked')
			.map(function () {
				return this.value;
			})
			.get(); // Get array.
		if (enabledSellers.length > 0) {
			document.getElementById('buyer-quote-upsell-button').disabled = false;
		} else {
			document.getElementById('buyer-quote-upsell-button').disabled = true;
		}
	});

	$('#buyer-quote-upsell-modal .submit-btn')
		.off('click.requestAll')
		.on('click.requestAll', () => {
			const upsellContainer = document.getElementById('buyer-quote-upsell-sellers');
			const selectedSellers = upsellContainer.getElementsByTagName('INPUT');
			let sellerProfileIdArray = [];
			const bpvid = $('#matches-list').data('bpvid');

			for (var i = 0; i < selectedSellers.length; i++) {
				if (selectedSellers[i].checked) {
					const sellerProfileId = selectedSellers[i].value;
					sellerProfileIdArray.push(sellerProfileId);
					const $sellerRow = $(
						`.seller-list-card[data-seller-profile-id=${sellerProfileId}]`,
					);
					window.rqfa.setQuoteRequested($sellerRow);
				}
			}

			window.ResponseActionModule.registerBulkResponseAction($('#project-seller-list'), {
				type: 'quote',
				bpvid: bpvid,
				sellerProfileIdArray: sellerProfileIdArray,
				projectId: getProjectHash(),
				source: 'buyer-interaction',
			});

			tracking('Feature', 'request_quote_upsell - requested', {
				projectId: getProjectHash(),
			});

			$('#buyer-quote-upsell-modal').modal('hide');
		});

	$('#buyer-quote-upsell-modal .close-button')
		.off('click.skip')
		.on('click.skip', () => {
			tracking('Feature', 'request_quote_upsell - skipped', {
				projectId: getProjectHash(),
			});
			$('#buyer-quote-upsell-modal').modal('hide');
		});
};
